import { DownOutlined, EditOutlined, AppstoreAddOutlined, UserAddOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import hasPermissions from '../../../utilities/hasPermissions';
import { useDeleteRoleConfirmation } from './DeleteRole';
import { useAddPermissionDrawer } from './RoleAddPermissionDrawer';
import { useAddUserDrawer } from './RoleAddUserDrawer';
import { useUpdateDrawer } from './RoleUpdateDrawer';

export type RoleActionsProps = { role: RoleSpecsFragment };

const RoleActions = ({ role }: RoleActionsProps) => {
    const { t } = useTranslation(['roleDetails']);
    const addPermissionDrawer = useAddPermissionDrawer(role);
    const addUserDrawer = useAddUserDrawer(role);
    const updateRoleDrawer = useUpdateDrawer(role);
    const deleteRolePopUp = useDeleteRoleConfirmation(role);

    const items = [
        hasPermissions(role.rolePermissions, [permissionKind.updateRole]) && {
            label: t('roleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateRoleDrawer.open,
        },

        hasPermissions(role.rolePermissions, [permissionKind.updateRole]) && {
            label: t('roleDetails:mainActionButtons.addUsers'),
            key: 'addUsers',
            icon: <UserAddOutlined />,
            onClick: addUserDrawer.open,
        },

        hasPermissions(role.rolePermissions, [permissionKind.updateRole]) && {
            label: t('roleDetails:mainActionButtons.addPermissions'),
            key: 'addPermissions',
            icon: <AppstoreAddOutlined />,
            onClick: addPermissionDrawer.open,
        },

        hasPermissions(role.rolePermissions, [permissionKind.deleteRole]) && {
            label: t('roleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteRolePopUp.open,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown menu={{ items }}>
                <Button type="primary">
                    <Space>
                        <span>{t('roleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {addPermissionDrawer.render()}
            {addUserDrawer.render()}
            {updateRoleDrawer.render()}
            {deleteRolePopUp.render()}
        </>
    );
};

export default RoleActions;
